import { render, staticRenderFns } from "./AreaEventHistorySettingsForm.vue?vue&type=template&id=d4f48ba2&scoped=true"
import script from "./AreaEventHistorySettingsForm.vue?vue&type=script&lang=ts"
export * from "./AreaEventHistorySettingsForm.vue?vue&type=script&lang=ts"
import style0 from "./AreaEventHistorySettingsForm.vue?vue&type=style&index=0&id=d4f48ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f48ba2",
  null
  
)

export default component.exports